/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';

import { ServiceContainer } from '../services/Service';

// TODO(vlad): remove this file wile moving files to folders with another structure
export type { Service, Registration } from '../services/Service';

const Service = new ServiceContainer();
export default Service;

export * from '../common/ExperimentModel';

export * from '../services/Format';
export * from '../services/DefaultHttpService';
export * from '../services/CacheService';

export * from './PlannerDomain';
export * from './PlannerDTOs';
// export type { Rollout } from './PlannerDTOs';
// export type { Script } from './PlannerMetadata';
export * from './PlannerMetadata';
export * from './PlannerService';
export * from './GrabAreaManagementService';

export * from './Configurations';
